import Api from './Api';

class _EnumsApi extends Api {
    loadLangs(params: any = {}): Promise<any> {
        return this.getLocalHttpClient().get('enums/langs', { params });
    }

    loadLocations(params: any = {}): Promise<any> {
        return this.getLocalHttpClient().get('enums/locations', { params });
    }

    loadBible(params: any = {}): Promise<any> {
        return this.getLocalHttpClient().get('enums/bible', { params });
    }

    loadColors(params: any = {}): Promise<any> {
        return this.getLocalHttpClient().get('enums/colors', { params });
    }
}

export const EnumsApi = new _EnumsApi();
